import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type ProjectMembershipNoOwnersErrorOptions = {
  project: ObjectId;
  user: ObjectId;
};

export class ProjectMembershipNoOwnersError extends FleekError<ProjectMembershipNoOwnersErrorOptions> {
  public name = 'ProjectMembershipNoOwnersError';

  toString = () => `Each project must have at least OWNER-role one membership.`;
}
